import React from "react";
import { Button, Card, CardBody, Col, Row, Input } from "reactstrap";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useGetAllEmployeeQuery } from "features/userManagement/UserManagementApiSlice";
import { useState } from "react";
import { useEffect } from "react";
import CustomSearchBar from "components/CustomSearchBar";
import {Box,Divider} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import {
  useGetCrmInsuranceLeadsByStatusQuery,
  useAssignLeadsToEmployeeMutation,
} from "./CmrApiSlice";
import { useGetStatesQuery, useGetDistrictByStateQuery } from "services/locationApiSlice"

import Pagination from "@mui/material/Pagination";
import { toast } from "react-toastify";
import { Tag } from "antd";
import Select from "react-select";
import Swal from "sweetalert2";

const CrmInsuranceAssignToEmployee = ({  setAssignEmployeeModal }) => {
  const [stateId, setStateId] = useState("")
  const [districtId, setDistrictId] = useState("")
  const { data: getStates } = useGetStatesQuery()
  const {data: dataDistrict,} = useGetDistrictByStateQuery(stateId)
  const [getEmployeList, setEmployeeList] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [selectedEmployeeId, setSelectedEmployeeId] = useState("");
  const [showErrorMessage, setErrorMessage] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const [stateList, setStateList] = useState([])
  const [districtList, setDistrictList] = useState([])
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [debouncedSearch2, setDebouncedSearch2] = useState("");


  const [pagination, setPagination] = useState({
    page: 1,
    pageCount: 0,
    perPage: 10,
  });
  const [searchKeyStatus, setSearchKeyStatus] = useState("");
   let product_name=""
    const status=""
  const {
    data: statusData,
    refetch: refetchStatus,
  } = useGetCrmInsuranceLeadsByStatusQuery({ pagination, searchKeyStatus,product_name,status });
  const [
    assignEmployee,
  ] = useAssignLeadsToEmployeeMutation();
  const [leadList, setLeadList] = useState([]);
  const { data: data, isLoading, refetch } = useGetAllEmployeeQuery({
    pagination,
    searchKey,stateId,districtId
  });
  const [ReportingId, setReportingId] = useState({
    reporting_to_id: "",
  });
  const [filterIdAgain, setFilterIdAgain] = useState([]);
  const columns = [

    { field: "full_name", headerName: "Name", width: 180 },
    { field: "phone_number", headerName: "Phone Number", width: 160 },
    { field: "lead_source", headerName: "Lead Source", width: 180 },

    {
        field: "current_status",
        headerName: "Application Status",
        width: 220,
        renderCell: (cellValues) => {
          const status = cellValues.row.current_status;
  
          const statusConfig = {
            "Lead Details Modified": {
              color: "blue",
            },
            Assigned: { color: "gold"},
            "Can Not Process": { color: "error", },
            "Lead Generated": { color: "volcano" },
          };
  
          const { color, icon } = statusConfig[status] || {
            color: "geekblue",
          };
  
          return (
            <Tag
              bordered={false}
              color={color}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "3px 9px",
                fontSize: "13px",
                fontWeight: "500",
                borderRadius: "6px",
              }}
            >
              {icon}
              <span>{status}</span>
            </Tag>
          );
        },
      },
      { field: "state_name", headerName: "State", width: 150 },
  
   

];

const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "35px", 
      height: "35px", 
      padding: "0px", 
      fontSize: "12px",
    }),
}
  useEffect(() => {
    const dataFromApi = statusData?.data?.results
      ? statusData?.data?.results
      : [];
    const paginationFromApi = statusData?.data?.pages
      ? {
          page: statusData?.data?.current_page,
          pageCount: statusData?.data?.pages,
          perPage: statusData?.data?.per_page,
        }
      : pagination;
    setPagination(paginationFromApi);
    setLeadList(dataFromApi);
    if (getStates != undefined) {
      setStateList(getStates?.data?.results)
  }
  }, [statusData,getStates]);

  useEffect(() => {
    setEmployeeList(data?.data?.results);
  }, [data]);

  const handleSelectedFle = (item) => {
    // console.log(item, "item");
    setSelectedEmployee(item);
    setReportingId(item);
    setSelectedEmployeeId(item.id);
    setErrorMessage(false);
  };

 
  const handlePerPageRecords = (e) => {
    setPagination({ ...pagination, ...{ perPage: e.target.value } });
  };
  const CustomPagination = () => {
    return (
      <>
        <select
          name="pages"
          onChange={handlePerPageRecords}
          style={{ padding: "2px", borderRadius: "7px" }}
        >
          <option value="10" selected={true ? pagination.perPage == 10 : false}>
            10
          </option>
          <option value="50" selected={true ? pagination.perPage == 50 : false}>
            50
          </option>
          <option
            value="100"
            selected={true ? pagination.perPage == 100 : false}
          >
            100
          </option>
        </select>
        <Pagination
          color="primary"
          count={pagination?.pageCount}
          page={pagination?.page}
          onChange={(event, value) => {
            setPagination({
              page: value,
              pageCount: pagination?.pageCount,
              perPage: pagination.perPage,
            });
          }}
          variant="outlined"
          shape="rounded"
        />
      </>
    );
  };


  const handleChangeSearchFiltered = (message) => {
    setSearchKeyStatus(message);
    refetchStatus();
  };
 

  const filterDataBasedId = (item) => {
    setFilterIdAgain(item);
  };

  const handleAssign = () => {
    if (selectedEmployee === "") {
       Swal.fire({
                           title: "Select Employee",
                           text: "Please select Employee to Assign Leads",
                           icon: "warning",
                           showCancelButton: true,
                           confirmButtonText: 'Continue',
                           cancelButtonText: 'Cancel',
                           confirmButtonIcon: 'fas fa-arrow-right', 
                         })
      return;
    }
    let payload = {
      employee_id: selectedEmployeeId,
      leads_id_list: filterIdAgain,
      employee_details: {
        employee_code: selectedEmployee.employee_code,
        full_name: selectedEmployee.full_name,
        phone_number: selectedEmployee.phone_number,
      },
    };
    if (filterIdAgain.length === 0) {
      Swal.fire({
        title: "Select Leads",
        text: "Please select Leads to Assign",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: 'Continue',
        cancelButtonText: 'Cancel',
        confirmButtonIcon: 'fas fa-arrow-right', 
      })
      return;
    }
    assignEmployee(payload)
      .unwrap()
      .then((data) => {
        toast.success("Users Assigned Successfully");
        setAssignEmployeeModal(false);
      })
      .catch((error) => {
        toast.error("Error while Assigning Users");
        return;
      });
  };
  const handleStateOptions = () => {
    let responseAgentArray = []
    stateList.map((state) => {
        responseAgentArray.push({ value: state.state_code, label: state.state_name, ConditionName: "state" },)
    })
    return responseAgentArray
}
const handleDistrictOptions = () => {
    let responseAgentArray = []
    districtList.map((district) => {
        responseAgentArray.push({ value: district.district_code, label: district.district_name, ConditionName: "district" },)
    })
    return responseAgentArray
}
const onLocationChange = (event) => {

    if (event.ConditionName == "state") {
        setDistrictId("")
        setStateId(event.value)
    }
    if (event.ConditionName == "district") {
        setDistrictId(event.value)
        setPagination({ page: 1, pageCount: 0, perPage: 50,
        })
    }
}

useEffect(() => {
    if (dataDistrict != undefined) {
        setDistrictList(dataDistrict?.data?.results)
    }
}, [dataDistrict])
const handleChangeSearch = (message) => {
  setSearchKey(message);

};
useEffect(() => {
const delay = setTimeout(() => {
    setDebouncedSearch(searchKey);
}, 1000); 

return () => clearTimeout(delay); 
}, [searchKey]);



const handleChangeSearch2 = (message) => {
  setSearchKeyStatus(message);

};
useEffect(() => {
const delay = setTimeout(() => {
    setDebouncedSearch2(searchKeyStatus);
}, 1000); 

return () => clearTimeout(delay); 
}, [searchKeyStatus]);


  return (
    <>
     
     
      <Row>
                <h5> Select Employee (<i className="text-warning" style={{fontWeight:"500",fontSize:"12px"}}> Please select an Employee from the list below to assign leads efficiently.</i>)</h5>

                    <div className="row mt-2 p-1">
                       
                <Col md="2" className="mt-4">
                <CustomSearchBar sendSearchFunction={handleChangeSearch} />
                  </Col>
                    <Col md="2">
                        <label> State</label>
                        <Select menuPlacement="auto" options={handleStateOptions()} onChange={onLocationChange} className=" mt-2" styles={customStyles} />
                    </Col>
                    <Col md="2">
                        <label> District</label>
                        <Select menuPlacement="auto" options={handleDistrictOptions()} onChange={onLocationChange} className=" mt-2" styles={customStyles} />
                    </Col>
                    <Col md="6">
                    {selectedEmployee?
                        <div>Selected Employee : <strong>{selectedEmployee.full_name} </strong></div>
                       :""}
                    </Col>
                    
                    </div>
                  
                 
                    {getEmployeList?.length > 0 ?  
                    <div 
    style={{
        gap: "12px",
        justifyContent: "center",
        maxHeight: "280px", 
        overflowY: "auto",
        padding: "10px",
        scrollbarWidth: "thin",
        msOverflowStyle: "none",
    }}
>
    <div className="row">
    {getEmployeList?.map((item, index) => (
  <div className="col-md-3">
    <Card
      key={index}
      className="cursor-pointer"
      style={{
        // backgroundColor: "#ffffff",
        backgroundColor:"#eaeaea",
        borderRadius: "8px",
        boxShadow: selectedEmployeeId === item.id
          ? "0px 4px 10px rgba(209, 209, 210, 0.4)"
          : "0px 2px 4px rgba(0, 0, 0, 0.1)",
        border: selectedEmployeeId === item.id
          ? "2px solid orange"
          : "1px solid #ddd",
        padding: "8px",
        transition: "all 0.3s ease",
        cursor: "pointer",
      }}
      onClick={() => handleSelectedFle(item)}
    >
      <CardBody className="p-2">
        <div className="d-flex align-items-center">
          <img
            src={item.profile_pic}
            width="45px"
            height="45px"
            style={{
              borderRadius: "50%",
              border: "1px solid #ddd",
              objectFit: "cover",
              marginRight: "10px",
            }}
          />
          <div>
            <span style={{ fontSize: "14px", fontWeight: "600", display: "block" }}>
              {item.full_name}
            </span>
            <span style={{ fontSize: "12px", color: "#666" }}>
              {item.phone_number}
            </span>
            <span style={{ fontSize: "12px", color: "#666" }}>
              {item.employee_code}
            </span>
          </div>
        </div>
      </CardBody>
    </Card>
  </div>
))}

</div>
</div>
:
<div className="text-center mt-2 ">No Record Found</div>
            }

<Divider className="mt-2"/>

                       <div className="d-flex justify-content-between mt-2">
                        <h5 className="mt-2"> Select Leads  (<i className="text-warning" style={{fontWeight:"500",fontSize:"12px"}}> Please select Leads from the list below to assign leads efficiently.</i>)</h5>

                        <CustomSearchBar sendSearchFunction={handleChangeSearch2} />

                            <Button
                        id="AddLeads"
                        className="buttonGreenDefaultColor"
                        // onClick={handleAssign}
                        onClick={handleAssign}
                        size="sm"
                      >
                        Assign Leads &nbsp;
                        <i className="mdi mdi-account-arrow-right custom-btn-fs fs-6"></i>
                        </Button>
                          
                    </div>
                         <Box sx={{ width: '100%', zIndex: "0" }} className="mt-3">
                                        <DataGrid
                                          rows={leadList}
                                          columns={columns}
                                          rowsPerPageOptions={[3]}
                                          checkboxSelection
                                          onRowSelectionModelChange={(item) => {
                                            filterDataBasedId(item);
                                          }}
                                          components={{
                                            Pagination: CustomPagination,
                                          }}
                                        />
                        </Box> 
                         </Row>






















    </>
  );
};

export default CrmInsuranceAssignToEmployee;












